import {dump as dumpYaml, load as loadYaml, loadAll as loadAllYaml, visit as visitYaml} from 'js-yaml'
import type {DumpOptions as JsYamlDumpOptions, LoadOptions as JsYamlLoadOptions} from 'js-yaml'

export const loadAll = loadAllYaml
export type DumpOptions = JsYamlDumpOptions
export type LoadOptions = JsYamlLoadOptions

export function dump(input: unknown, options?: JsYamlDumpOptions): string {
  if (!options?.forceQuotes) return dumpYaml(input, options)

  return dumpYaml(input, {
    ...options,
    forceQuotes: false,
    transform(documents) {
      options.transform?.(documents)
      visitYaml(documents, (node, context) => {
        if (node.kind !== 'scalar' || context.isKey || node.tag !== 'tag:yaml.org,2002:str') return

        node.style.doubleQuoted = options.quoteStyle === 'double'
        node.style.singleQuoted = options.quoteStyle !== 'double'
      })
    },
  })
}

export function load(input: string, options?: JsYamlLoadOptions): unknown {
  if (input.trim() === '') return undefined

  return loadYaml(input, options)
}
